import Api from "../../../api/index";

const Match = {
  namespaced: true,

  state: {
    oneMatch: null,
    goalPapers: [],
    cardPapers: [],
    breakerPapers: []
  },
  getters: {
    teamA: state => {
      if (state.oneMatch)
        return {
          ...state.oneMatch.data.attributes.home_team.data.attributes,
          squads: state.oneMatch.data.attributes.home_team.data.attributes.squads.data.map(
            o => o.attributes
          )
        };
      else return null;
    },
    teamB: state => {
      if (state.oneMatch)
        return {
          ...state.oneMatch.data.attributes.away_team.data.attributes,
          squads: state.oneMatch.data.attributes.away_team.data.attributes.squads.data.map(
            o => o.attributes
          )
        };
      else return null;
    }
  },

  mutations: {
    setOneMatch(state, item) {
      state.oneMatch = item; // item.data
    },
    clearMatch(state) {
      state.oneMatch = null;
      state.goalPapers = [];
      state.cardPapers = [];
      state.breakerPapers = [];
    },
    setGoalPapers(state, item) {
      state.goalPapers = item;
    },
    setCardPapers(state, item) {
      state.cardPapers = item;
    },
    setBreakerPapers(state, item) {
      state.breakerPapers = item;
    }
  },

  actions: {
    show(context, item_id) {
      Api.Match.show(item_id)
        .then(response => response.data)
        .then(item => {
          context.commit("setOneMatch", item);

          if (item.data.attributes.eventGoals.length > 0)
            context.commit("setGoalPapers", item.data.attributes.eventGoals);
          if (item.data.attributes.eventCards.length > 0)
            context.commit("setCardPapers", item.data.attributes.eventCards);
          if (item.data.attributes.eventBreakers.length > 0)
            context.commit(
              "setBreakerPapers",
              item.data.attributes.eventBreakers
            );
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};

export default Match;
